export enum UserStatus {
  PROSPECT = 'prospect',
  CLIENT_ACTIVE = 'client_active',
  CLIENT_EXPIRED = 'client_expired'
}
